<app-popup-layout #modal>
  <div class="modal-container">
    <header class="modal-header">
      <p class="modal-title" id="modal-basic-title">Select a Card Provider</p>
      <app-close-button
        class="ms-auto"
        (onCloseEmitter)="modal.dismiss()"
      ></app-close-button>
    </header>

    <div class="modal-body" [formGroup]="form">
      @for (cp of creditProvider; track cp) {
        <label class="radio-container">
          <input
            type="radio"
            name="radioGroup"
            [value]="cp.value"
            formControlName="cardProviderTenant"
            />
          <img class="img-{{ cp.value }}" [src]="cp.url" [alt]="cp.value" />
        </label>
      }
      <!-- <mat-radio-group
      class="radio-group"
      color="primary"
      aria-label="Select an option"
      formControlName="cardProviderTenant"
      >
      <mat-radio-button

        >
        <img
            [ngClass]="{
              opacity_0: cardProvider !== cp.value
            }"
          class="right-sign ms-auto me-3 mt-3"
          src="/assets/svg/chip-success-meal.svg"
          alt="Right"
          />
        <img
          formControlName="cardProviderTenant"
            [ngClass]="{
              'enkash-img': cp.value === 'ENKASH',
              'au-img': cp.value === 'AU_BANK'
            }"
          [src]="cp.url"
          [alt]="cp.value"
          />
      </mat-radio-button>
    </mat-radio-group> -->
  </div>

  <!-- <p class="modal-sub-body">
  Please continue & complete the OTP authentication to access information
  for the selected provider
</p> -->

<div class="modal-footer justify-center">
  <button
    class="footer-button"
    mat-flat-button
    color="primary"
    [disabled]="form.invalid"
    (click)="modal.close(form.get('cardProviderTenant').value)"
    >
    CONTINUE
  </button>
</div>
</div>
</app-popup-layout>
